import { Component, OnInit, inject } from "@angular/core";
import { provideTranslocoScope, TranslocoDirective } from "@jsverse/transloco";
import { AboutService } from "./services/about.service";
import { AboutModel } from "./models/AboutModel";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { firstValueFrom } from "rxjs";
import { CerrixLoaderComponent } from "@app/shared/components/cerrix-loader/cerrix-loader.component";

@Component({
    selector: "app-about",
    templateUrl: "./about.component.html",
    styleUrls: ["./about.component.scss"],
    providers: [provideTranslocoScope("about")],
    imports: [TranslocoDirective, CerrixLoaderComponent],
})
export class AboutComponent implements OnInit {
    private aboutService = inject(AboutService);

    public tab: TabModel;

    public about: AboutModel;

    public currentDate = new Date();
    public halloweenLogo = this.currentDate.getDate() === 31 && this.currentDate.getMonth() === 9;

    public async ngOnInit() {
        this.tab.showLoader = true;

        try {
            this.about = await firstValueFrom(this.aboutService.getAbout());
        } finally {
            this.tab.showLoader = false;
        }
    }
}
